// New src/Common/components/hidden_autofill/hidden_autofill.component.ts CommonHiddenAutofillComponent
// Old src/CaseDotStar.ServicePackages.Frontend.Common/scripts/common/directives/common_hidden_autofill_directive.js commonHiddenAutofillDirective

import {
	Component,
	Input,
} from '@angular/core';

@Component({
	selector: 'common-hidden-autofill',
	templateUrl: './hidden_autofill.component.pug',
	styleUrls: [
		'./hidden_autofill.component.sass',
	],
})
export class CommonHiddenAutofillComponent {
	@Input() type: string;
}
